export enum LegacyMigrationMessages {
  legacyMigrationTitle = "legacyMigration.title",
  legacyMigrationSubtitle = "legacyMigration.subtitle",
  legacyMigrationNotConfigured = "legacyMigration.notConfigured",
  legacyMigrationForbidden = "legacyMigration.forbidden",
  legacyMigrationSessionExpired = "legacyMigration.sessionExpired",

  // region Steps
  legacyMigrationStepCustomer = "legacyMigration.step.customer",
  legacyMigrationStepReview = "legacyMigration.step.review",
  // endregion Steps

  // region Step 1 — the customer
  legacyMigrationChooseTitle = "legacyMigration.choose.title",
  legacyMigrationChooseHint = "legacyMigration.choose.hint",
  legacyMigrationSearchTenant = "legacyMigration.searchTenant",
  legacyMigrationNoTenants = "legacyMigration.noTenants",
  legacyMigrationTenantsUnavailable = "legacyMigration.tenantsUnavailable",
  legacyMigrationInactiveTenant = "legacyMigration.inactiveTenant",
  legacyMigrationStart = "legacyMigration.start",
  // endregion Step 1 — the customer

  // region Step 2 — reading the legacy database
  legacyMigrationReadingTitle = "legacyMigration.reading.title",
  legacyMigrationReadingHint = "legacyMigration.reading.hint",
  // endregion Step 2 — reading the legacy database

  // region Step 3 — the review
  legacyMigrationReviewTitle = "legacyMigration.review.title",
  legacyMigrationReviewHint = "legacyMigration.review.hint",
  legacyMigrationSearchUser = "legacyMigration.searchUser",
  legacyMigrationSelectAll = "legacyMigration.selectAll",
  legacyMigrationClearAll = "legacyMigration.clearAll",
  legacyMigrationColumnUser = "legacyMigration.column.user",
  legacyMigrationColumnPassword = "legacyMigration.column.password",
  legacyMigrationColumnModules = "legacyMigration.column.modules",
  legacyMigrationPasswordKept = "legacyMigration.password.kept",
  legacyMigrationPasswordReset = "legacyMigration.password.reset",
  legacyMigrationPasswordKeptHint = "legacyMigration.password.keptHint",
  legacyMigrationPasswordWeakHint = "legacyMigration.password.weakHint",
  legacyMigrationLockNeedsKeptPassword = "legacyMigration.lock.needsKeptPassword",
  legacyMigrationNotContractedBanner = "legacyMigration.notContractedBanner",
  legacyMigrationNotContracted = "legacyMigration.notContracted",
  legacyMigrationIneligibleCount = "legacyMigration.ineligibleCount",
  legacyMigrationBack = "legacyMigration.back",
  legacyMigrationExportList = "legacyMigration.exportList",
  legacyMigrationExportListHint = "legacyMigration.exportList.hint",
  legacyMigrationExportListEmail = "legacyMigration.exportList.email",
  legacyMigrationExportListStatus = "legacyMigration.exportList.status",
  legacyMigrationExportListLockLegacy = "legacyMigration.exportList.lockLegacy",
  legacyMigrationExportListNewLegacyPassword = "legacyMigration.exportList.newLegacyPassword",
  legacyMigrationConfirm = "legacyMigration.confirm",
  legacyMigrationConfirmAction = "legacyMigration.confirm.action",
  legacyMigrationConfirmTitle = "legacyMigration.confirm.title",
  legacyMigrationConfirmBody = "legacyMigration.confirm.body",
  legacyMigrationConfirmPasswords = "legacyMigration.confirm.passwords",
  // endregion Step 3 — the review

  // region Step 4 — provisioning
  legacyMigrationMigratingTitle = "legacyMigration.migrating.title",
  legacyMigrationMigratingHint = "legacyMigration.migrating.hint",
  legacyMigrationProgress = "legacyMigration.progress",
  legacyMigrationErrorsSoFar = "legacyMigration.errorsSoFar",
  legacyMigrationStop = "legacyMigration.stop",
  legacyMigrationStopping = "legacyMigration.stopping",
  // endregion Step 4 — provisioning

  // region Step 5 — the outcome
  legacyMigrationDoneTitle = "legacyMigration.done.title",
  legacyMigrationDoneWithErrorsTitle = "legacyMigration.doneWithErrors.title",
  legacyMigrationStoppedTitle = "legacyMigration.stopped.title",
  legacyMigrationDoneHint = "legacyMigration.done.hint",
  legacyMigrationStatCreated = "legacyMigration.stat.created",
  legacyMigrationStatUpdated = "legacyMigration.stat.updated",
  legacyMigrationStatSkipped = "legacyMigration.stat.skipped",
  legacyMigrationStatErrors = "legacyMigration.stat.errors",
  legacyMigrationExport = "legacyMigration.export",
  legacyMigrationRetry = "legacyMigration.retry",
  legacyMigrationLeave = "legacyMigration.leave",
  // endregion Step 5 — the outcome

  // region Topcon Legado lock
  legacyMigrationColumnLegacy = "legacyMigration.column.legacy",
  legacyMigrationLock = "legacyMigration.lock",
  legacyMigrationLockAll = "legacyMigration.lockAll",
  legacyMigrationAlsoUses = "legacyMigration.alsoUses",
  legacyMigrationAlreadyLocked = "legacyMigration.alreadyLocked",
  legacyMigrationReviewLockHint = "legacyMigration.review.lockHint",
  legacyMigrationConfirmLocks = "legacyMigration.confirm.locks",
  legacyMigrationLockedSummary = "legacyMigration.done.locked",
  legacyMigrationLockFailed = "legacyMigration.done.lockFailed",
  // endregion Topcon Legado lock

  // region Access to the screen
  legacyMigrationManageAccess = "legacyMigration.access.open",
  legacyMigrationAccessTitle = "legacyMigration.access.title",
  legacyMigrationAccessSubtitle = "legacyMigration.access.subtitle",
  legacyMigrationAccessGrantLabel = "legacyMigration.access.grantLabel",
  legacyMigrationAccessGrant = "legacyMigration.access.grant",
  legacyMigrationAccessRevoke = "legacyMigration.access.revoke",
  legacyMigrationAccessEmpty = "legacyMigration.access.empty",
  legacyMigrationAccessGrantedBy = "legacyMigration.access.grantedBy",
  legacyMigrationAccessLoading = "legacyMigration.access.loading",
  legacyMigrationAccessLoadError = "legacyMigration.access.loadError",
  legacyMigrationTryAgain = "legacyMigration.tryAgain",
  // endregion Access to the screen

  // region Long user lists
  legacyMigrationSelectShown = "legacyMigration.selectShown",
  legacyMigrationClearShown = "legacyMigration.clearShown",
  legacyMigrationFilterAll = "legacyMigration.filter.all",
  legacyMigrationFilterLeftOut = "legacyMigration.filter.leftOut",
  legacyMigrationFilterOtherAreas = "legacyMigration.filter.otherAreas",
  legacyMigrationFilterOnlyCrm = "legacyMigration.filter.onlyCrm",
  legacyMigrationNoUsersFound = "legacyMigration.noUsersFound",
  legacyMigrationPageRange = "legacyMigration.page.range",
  legacyMigrationPageNext = "legacyMigration.page.next",
  legacyMigrationPagePrevious = "legacyMigration.page.previous",
  legacyMigrationPageGoTo = "legacyMigration.page.goTo",
  legacyMigrationStepResult = "legacyMigration.step.result",
  legacyMigrationInIdentity = "legacyMigration.inIdentity",
  legacyMigrationInIdentityHint = "legacyMigration.inIdentity.hint",
  legacyMigrationFilterInIdentity = "legacyMigration.filter.inIdentity",
  // endregion Long user lists

  // region Plural forms
  //
  // i18next picks these from the `count` option (JSON v4: _one / _other); the
  // key without a suffix stays as the fallback when no count is given.
  legacyMigrationChooseHintZero = "legacyMigration.choose.hint_zero",
  legacyMigrationChooseHintOne = "legacyMigration.choose.hint_one",
  legacyMigrationChooseHintOther = "legacyMigration.choose.hint_other",
  legacyMigrationReviewTitleZero = "legacyMigration.review.title_zero",
  legacyMigrationReviewTitleOne = "legacyMigration.review.title_one",
  legacyMigrationReviewTitleOther = "legacyMigration.review.title_other",
  legacyMigrationIneligibleCountOne = "legacyMigration.ineligibleCount_one",
  legacyMigrationIneligibleCountOther = "legacyMigration.ineligibleCount_other",
  legacyMigrationConfirmZero = "legacyMigration.confirm_zero",
  legacyMigrationConfirmOne = "legacyMigration.confirm_one",
  legacyMigrationConfirmOther = "legacyMigration.confirm_other",
  legacyMigrationConfirmBodyOne = "legacyMigration.confirm.body_one",
  legacyMigrationConfirmBodyOther = "legacyMigration.confirm.body_other",
  legacyMigrationConfirmPasswordsZero = "legacyMigration.confirm.passwords_zero",
  legacyMigrationConfirmPasswordsOne = "legacyMigration.confirm.passwords_one",
  legacyMigrationConfirmPasswordsOther = "legacyMigration.confirm.passwords_other",
  legacyMigrationProgressOne = "legacyMigration.progress_one",
  legacyMigrationProgressOther = "legacyMigration.progress_other",
  legacyMigrationErrorsSoFarOne = "legacyMigration.errorsSoFar_one",
  legacyMigrationErrorsSoFarOther = "legacyMigration.errorsSoFar_other",
  legacyMigrationConfirmLocksOne = "legacyMigration.confirm.locks_one",
  legacyMigrationConfirmLocksOther = "legacyMigration.confirm.locks_other",
  legacyMigrationLockFailedOne = "legacyMigration.done.lockFailed_one",
  legacyMigrationLockFailedOther = "legacyMigration.done.lockFailed_other",
  legacyMigrationSelectShownOne = "legacyMigration.selectShown_one",
  legacyMigrationSelectShownOther = "legacyMigration.selectShown_other",
  legacyMigrationClearShownOne = "legacyMigration.clearShown_one",
  legacyMigrationClearShownOther = "legacyMigration.clearShown_other",
  // endregion Plural forms

  // region Outcome of a single user (backend value)
  legacyMigrationOutcomeCreated = "legacyMigration.outcome.CREATED",
  legacyMigrationOutcomeUpdated = "legacyMigration.outcome.UPDATED",
  legacyMigrationOutcomeSkipped = "legacyMigration.outcome.SKIPPED",
  legacyMigrationOutcomeError = "legacyMigration.outcome.ERROR",
  // endregion Outcome of a single user (backend value)

  // region Why a user was left out or what happened to them (backend code)
  legacyMigrationReasonNoEmail = "legacyMigration.reason.NO_EMAIL",
  legacyMigrationReasonNoAccessRows = "legacyMigration.reason.NO_ACCESS_ROWS",
  legacyMigrationReasonNoSsoAccess = "legacyMigration.reason.NO_SSO_ACCESS",
  legacyMigrationReasonInOtherTenant = "legacyMigration.reason.IN_OTHER_TENANT",
  legacyMigrationReasonTopconStaff = "legacyMigration.reason.TOPCON_STAFF",
  legacyMigrationReasonAlreadyProvisioned = "legacyMigration.reason.ALREADY_PROVISIONED",
  legacyMigrationReasonNoModulesSelected = "legacyMigration.reason.NO_MODULES_SELECTED",
  legacyMigrationReasonRemovedFromSource = "legacyMigration.reason.REMOVED_FROM_SOURCE",
  legacyMigrationReasonEmailChanged = "legacyMigration.reason.EMAIL_CHANGED",
  legacyMigrationReasonResetEmailFailed = "legacyMigration.reason.RESET_EMAIL_FAILED",
  legacyMigrationReasonProvisionFailed = "legacyMigration.reason.PROVISION_FAILED",
  legacyMigrationReasonInvalidEmail = "legacyMigration.reason.INVALID_EMAIL",
  legacyMigrationReasonNoValidModules = "legacyMigration.reason.NO_VALID_MODULES",
  // endregion Why a user was left out or what happened to them (backend code)

  // region What happened to the Topcon Legado password (backend code)
  legacyMigrationLockReasonLocked = "legacyMigration.lockReason.LEGACY_LOCKED",
  legacyMigrationLockReasonAlreadyLocked = "legacyMigration.lockReason.LEGACY_ALREADY_LOCKED",
  legacyMigrationLockReasonSkippedPasswordNotKept = "legacyMigration.lockReason.LEGACY_LOCK_SKIPPED_PASSWORD_NOT_KEPT",
  legacyMigrationLockReasonPasswordChanged = "legacyMigration.lockReason.LEGACY_LOCK_PASSWORD_CHANGED",
  legacyMigrationLockReasonDenied = "legacyMigration.lockReason.LEGACY_LOCK_DENIED",
  legacyMigrationLockReasonFailed = "legacyMigration.lockReason.LEGACY_LOCK_FAILED",
  // endregion What happened to the Topcon Legado password (backend code)

  // region Rejected request (backend error code)
  legacyMigrationErrorForbidden = "legacyMigration.error.LEGACY_MIGRATION_FORBIDDEN",
  legacyMigrationErrorTenantNotFound = "legacyMigration.error.LEGACY_MIGRATION_TENANT_NOT_FOUND",
  legacyMigrationErrorDataSourceNotConfigured = "legacyMigration.error.LEGACY_MIGRATION_DATA_SOURCE_NOT_CONFIGURED",
  legacyMigrationErrorDataSourceNotFound = "legacyMigration.error.LEGACY_MIGRATION_DATA_SOURCE_NOT_FOUND",
  legacyMigrationErrorDataSourceUnavailable = "legacyMigration.error.LEGACY_MIGRATION_DATA_SOURCE_UNAVAILABLE",
  legacyMigrationErrorModuleNotContracted = "legacyMigration.error.LEGACY_MIGRATION_MODULE_NOT_CONTRACTED",
  legacyMigrationErrorInvalidRequest = "legacyMigration.error.LEGACY_MIGRATION_INVALID_REQUEST",
  legacyMigrationErrorDataSourceAccessDenied = "legacyMigration.error.LEGACY_MIGRATION_DATA_SOURCE_ACCESS_DENIED",
  legacyMigrationErrorUnknown = "legacyMigration.error.unknown",
  // endregion Rejected request (backend error code)

  // region Rejected access change (staff-permission error code, mapped in messages.ts)
  legacyMigrationStaffErrorForbidden = "legacyMigration.staffError.FORBIDDEN",
  legacyMigrationStaffErrorUserNotFound = "legacyMigration.staffError.USER_NOT_FOUND",
  legacyMigrationStaffErrorTargetNotAdmin = "legacyMigration.staffError.TARGET_NOT_ADMIN",
  legacyMigrationStaffErrorCannotRevokeSelf = "legacyMigration.staffError.CANNOT_REVOKE_SELF",
  // endregion Rejected access change (staff-permission error code, mapped in messages.ts)

  // region TopconFLEET source
  legacyMigrationSourceLabel = "legacyMigration.source.label",
  legacyMigrationSourceCrm = "legacyMigration.source.CRM",
  legacyMigrationSourceFleet = "legacyMigration.source.FLEET",
  legacyMigrationFleetSubtitle = "legacyMigration.fleet.subtitle",
  legacyMigrationFleetChooseHint = "legacyMigration.fleet.choose.hint",
  legacyMigrationFleetChooseHintZero = "legacyMigration.fleet.choose.hint_zero",
  legacyMigrationFleetChooseHintOne = "legacyMigration.fleet.choose.hint_one",
  legacyMigrationFleetChooseHintOther = "legacyMigration.fleet.choose.hint_other",
  legacyMigrationFleetNotContracted = "legacyMigration.fleet.notContracted",
  legacyMigrationFleetNotContractedHint = "legacyMigration.fleet.notContractedHint",
  legacyMigrationFleetReadingHint = "legacyMigration.fleet.reading.hint",
  legacyMigrationFleetReviewHint = "legacyMigration.fleet.review.hint",
  legacyMigrationFleetReviewLockHint = "legacyMigration.fleet.review.lockHint",
  legacyMigrationFleetPasswordHint = "legacyMigration.fleet.passwordHint",
  legacyMigrationFleetLockNeedsSignIn = "legacyMigration.fleet.lockNeedsSignIn",
  legacyMigrationFleetAdmin = "legacyMigration.fleet.admin",
  legacyMigrationFleetAdminHint = "legacyMigration.fleet.adminHint",
  legacyMigrationFleetSignedIn = "legacyMigration.fleet.signedIn",
  legacyMigrationFleetColumnLegacy = "legacyMigration.fleet.columnLegacy",
  legacyMigrationFleetLockAll = "legacyMigration.fleet.lockAll",
  legacyMigrationFleetExportListLockLegacy = "legacyMigration.fleet.exportList.lockLegacy",
  legacyMigrationFleetExportListNewPassword = "legacyMigration.fleet.exportList.newPassword",
  legacyMigrationFleetConfirmLocks = "legacyMigration.fleet.confirm.locks",
  legacyMigrationFleetConfirmLocksOne = "legacyMigration.fleet.confirm.locks_one",
  legacyMigrationFleetConfirmLocksOther = "legacyMigration.fleet.confirm.locks_other",
  legacyMigrationFleetLockedSummary = "legacyMigration.fleet.done.lockedSummary",
  legacyMigrationFleetLockFailed = "legacyMigration.fleet.done.lockFailed",
  legacyMigrationFleetLockFailedOne = "legacyMigration.fleet.done.lockFailed_one",
  legacyMigrationFleetLockFailedOther = "legacyMigration.fleet.done.lockFailed_other",
  legacyMigrationFleetLockReasonLocked = "legacyMigration.fleet.lockReason.LEGACY_LOCKED",
  legacyMigrationFleetLockReasonSkippedPasswordNotKept = "legacyMigration.fleet.lockReason.LEGACY_LOCK_SKIPPED_PASSWORD_NOT_KEPT",
  legacyMigrationFleetLockReasonDenied = "legacyMigration.fleet.lockReason.LEGACY_LOCK_DENIED",
  legacyMigrationFleetLockReasonFailed = "legacyMigration.fleet.lockReason.LEGACY_LOCK_FAILED",
  legacyMigrationLockReasonUserGone = "legacyMigration.lockReason.LEGACY_LOCK_USER_GONE",
  legacyMigrationReasonFleetSuperAdmin = "legacyMigration.reason.FLEET_SUPER_ADMIN",
  legacyMigrationReasonFleetInactive = "legacyMigration.reason.FLEET_INACTIVE",
  legacyMigrationErrorFleetNotConfigured = "legacyMigration.error.LEGACY_MIGRATION_FLEET_NOT_CONFIGURED",
  legacyMigrationErrorFleetUnavailable = "legacyMigration.error.LEGACY_MIGRATION_FLEET_UNAVAILABLE",
  legacyMigrationErrorFleetTokenRejected = "legacyMigration.error.LEGACY_MIGRATION_FLEET_TOKEN_REJECTED",
  legacyMigrationErrorFleetOutdated = "legacyMigration.error.LEGACY_MIGRATION_FLEET_OUTDATED",
  legacyMigrationErrorFleetCorporateSso = "legacyMigration.error.LEGACY_MIGRATION_FLEET_CORPORATE_SSO",

  // Screen clarity: lock callout, confirmation, result per user
  legacyMigrationLockCalloutTitle = "legacyMigration.review.lockCalloutTitle",
  legacyMigrationFleetLockCalloutTitle = "legacyMigration.fleet.review.lockCalloutTitle",
  legacyMigrationLockHelp = "legacyMigration.review.lockHelp",
  legacyMigrationFleetLockHelp = "legacyMigration.fleet.review.lockHelp",
  legacyMigrationFleetSignedInHint = "legacyMigration.fleet.signedInHint",
  legacyMigrationConfirmEmails = "legacyMigration.confirm.emails",
  legacyMigrationConfirmEmailsZero = "legacyMigration.confirm.emails_zero",
  legacyMigrationConfirmEmailsOne = "legacyMigration.confirm.emails_one",
  legacyMigrationConfirmEmailsOther = "legacyMigration.confirm.emails_other",
  legacyMigrationFleetConfirmEmails = "legacyMigration.fleet.confirm.emails",
  legacyMigrationFleetConfirmEmailsZero = "legacyMigration.fleet.confirm.emails_zero",
  legacyMigrationFleetConfirmEmailsOne = "legacyMigration.fleet.confirm.emails_one",
  legacyMigrationFleetConfirmEmailsOther = "legacyMigration.fleet.confirm.emails_other",
  legacyMigrationConfirmRerun = "legacyMigration.confirm.rerun",
  legacyMigrationFleetDoneHint = "legacyMigration.fleet.done.hint",
  legacyMigrationResultTitle = "legacyMigration.result.title",
  legacyMigrationResultOnlyProblems = "legacyMigration.result.onlyProblems",
  legacyMigrationColumnResult = "legacyMigration.result.columnResult",
  legacyMigrationColumnDetail = "legacyMigration.result.columnDetail",
  legacyMigrationResultPasswordKept = "legacyMigration.result.passwordKept",
  legacyMigrationResultEmailSent = "legacyMigration.result.emailSent",
  legacyMigrationResultLockNotAsked = "legacyMigration.result.lockNotAsked"
  // endregion TopconFLEET source
}

export type TranslationLegacyMigrationMessages = Record<LegacyMigrationMessages, string>;
